module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[12]133.f29873b.woff2";